import { InjectionToken, Type } from '@angular/core';

export const NODE_DETAIL_POPOVER_COMPONENT = new InjectionToken<Type<unknown>>('NODE_DETAIL_POPOVER_COMPONENT');
